import { humanizePriceFromCents as humanizePriceFromCentsBase } from '@i22/rocket';

export const humanizePriceFromCents = (value: number) =>
  humanizePriceFromCentsBase(value, { hideTrailingZeros: true });
